import { render, staticRenderFns } from "./OrganizationPointOfContactTable.vue?vue&type=template&id=4c27838e&"
import script from "./OrganizationPointOfContactTable.vue?vue&type=script&lang=ts&"
export * from "./OrganizationPointOfContactTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c27838e')) {
      api.createRecord('4c27838e', component.options)
    } else {
      api.reload('4c27838e', component.options)
    }
    module.hot.accept("./OrganizationPointOfContactTable.vue?vue&type=template&id=4c27838e&", function () {
      api.rerender('4c27838e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/organization/profile/point-of-contact/OrganizationPointOfContactTable.vue"
export default component.exports